import { useRouter } from "@uirouter/react";
import BN from "bn.js";
import { useTranslation } from "react-i18next";
import { compose } from "redux";
import { useAppLoader } from "../../../../components/loader/app-loader-hook";
import { BillingDTO } from "../../../../store/billing/models/dto";
import { BillingService } from "../../../../store/billing/service";
import {
  isApiError,
  processErrorFromPromise,
} from "../../../../store/errors/utils";
import { useBrowserWallet } from "../../../../store/wallets/crypto";
import { BillingRoutes } from "../../routes";

export function usePurchase(
  credits: number,
  amount: number,
  chain: BillingDTO.Responses.GetSKRTAddresses.T[number]
) {
  const { purchase } = useBrowserWallet();
  const loader = useAppLoader();
  const router = useRouter();
  const { t } = useTranslation("billing");

  return compose(loader, async () => {
    const val = new BN(amount * 100);

    try {
      const receipt = await purchase.fold(
        () => {
          throw new Error(t("trying-to-purchase-but-wallet-is-not-connected"));
        },
        (p) => p(val)
      );

      if (receipt) {
        try {
          const { id } = await BillingService.purchase({
            buyerWallet: {
              address: receipt.from,
              chain: chain.chain,
            },
            credits,
            currency: "USDT",
          });
          await BillingService.confirmPurchase(id, {
            sekuritanceWallet: chain,
            transactionHash: receipt.transactionHash,
          });
          router.stateService.go(BillingRoutes.names.result, {
            transactionHash: receipt.transactionHash,
            purchaseID: id,
          });
        } catch (apiError: any) {
          if (apiError.response.statusCode !== 401) {
            router.stateService.go(BillingRoutes.names.result, {
              transactionHash: receipt.transactionHash,
              error: new Error(
                isApiError(apiError)
                  ? apiError.response.body.errors?.[0]?.description
                  : t("an-error-has-occured-please-contact-customer-support")
              ),
              purchaseID: "", // otheriwse it will fail :/
            });
          }
        }
      }
    } catch (e: any) {
      processErrorFromPromise(e);
    }
  });
}
